import * as types from './constants/theme'

export const toggleDarkMode = (value) =>{
    return(dispatch) =>{
        dispatch({type: types.TOGGLE_DARK_MODE, theme:value})
    }
}